import src from "./get-started-animation.svg";

export function GetStartedAnimation() {
    return <img src={src} alt="" />;
}
